import type {SettingsState, BaseLayer} from '@src/stores/types.ts';
import {BASE_LAYERS} from '@apps-common/ui-maps/constants.js';
import {
  COORDINATE_SYSTEMS,
  CoordinateSystem,
} from '@src/constants/coordinateSystems.ts';
import {
  AREA_UNITS,
  type AreaUnit,
  DISTANCE_UNITS,
  type DistanceUnit,
  MEASUREMENT_SYSTEMS,
  type MeasurementSystem,
} from '@src/constants/measureUnits.ts';
import {StateCreator} from 'zustand';

const defaultUnits = {
  area: {
    [MEASUREMENT_SYSTEMS.metric]: AREA_UNITS.metric.km2,
    [MEASUREMENT_SYSTEMS.usc]: AREA_UNITS.usc.mi2,
  },
  distance: {
    [MEASUREMENT_SYSTEMS.metric]: DISTANCE_UNITS.metric.km,
    [MEASUREMENT_SYSTEMS.usc]: DISTANCE_UNITS.usc.mi,
  },
};

export const initialState = {
  baseLayer: BASE_LAYERS.SATELLITE,
  coordinateSystem: COORDINATE_SYSTEMS.dd,
  measurement: {
    system: MEASUREMENT_SYSTEMS.metric,
    areaUnit: defaultUnits.area.metric,
    distanceUnit: defaultUnits.distance.metric,
  },
};

export const setSettingsSlice: StateCreator<
  SettingsState,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [['zustand/persist', unknown]],
  SettingsState
> = set => ({
  ...initialState,
  setBaseLayer: (layer: BaseLayer) =>
    set(
      state => {
        state.baseLayer = layer;
      },
      undefined,
      'settings/setBaseLayer',
    ),
  setCoordinateSystem: (system: CoordinateSystem) =>
    set(state => {
      state.coordinateSystem = system;
    }),

  setMeasurementSystem: (system: MeasurementSystem) =>
    set(state => {
      state.measurement.system = system;
      state.measurement.areaUnit = defaultUnits.area[system];
      state.measurement.distanceUnit = defaultUnits.distance[system];
    }),
  setAreaUnit: (unit: AreaUnit) =>
    set(state => {
      state.measurement.areaUnit = unit;
    }),
  setDistanceUnit: (unit: DistanceUnit) =>
    set(state => {
      state.measurement.distanceUnit = unit;
    }),
});
